import { IconButton } from "@mui/material"
import { AuthoringAmendsContentDialog } from "authoring/routes/project/amends/components/authoring-amends-content-dialog"
import { normalizeAudienceAmends } from "authoring/routes/project/amends/lib/audience-aware-amends.mjs"
import { hasLongContent } from "authoring/routes/project/amends/lib/amends-content-preview"
import { isTaskAmendsKey } from "authoring/routes/project/amends/lib/task-amends-key"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"

export function TaskAuthorNoteBoxAction({ amend }) {
    const openTaskNoteDialog = useDialog(<AuthoringAmendsContentDialog />, { maxWidth: "md", fullWidth: true })
    const note = normalizeAudienceAmends(amend?.payload ?? {})

    if (!isTaskAuthorNote(amend)) return null
    if (!isLongNote(note)) return null

    return (
        <IconButton
            aria-label="View author note"
            size="small"
            color="primary"
            sx={{ p: 0.25, mt: 0.25 }}
            onClick={showTaskAuthorNote}
            data-cy="task-author-note-view-details"
        >
            <Iconify icon="mdi:eye" width={18} />
        </IconButton>
    )

    async function showTaskAuthorNote() {
        await openTaskNoteDialog({ noteData: note, title: "Author Note" })
    }
}

function isTaskAuthorNote(amend) {
    const amendsKey = amend?.payload?.amendsKey ?? amend?.payload?.field
    return isTaskAmendsKey(amendsKey)
}

function isLongNote(note) {
    if (note.isSplit) return hasLongContent(note.internalContent) || hasLongContent(note.externalContent)
    return hasLongContent(note.content)
}
